import React, { useEffect, useState } from "react";
import _OrderRow from "./_OrderRow";
import { FaSearch } from "react-icons/fa";
import { useAppContext } from "../../../../../../Components/AppProvider";

function _PartialPayment() {
  const [expandedId, setExpandedId] = useState(null);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [partialOrder, setPartialOrder] = useState([]);
  const [updatePartialOrder, setUpdatePartialOrder] = useState(false);

  const { setCountListUpdate } = useAppContext();
  // ✅ search state
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ keep track of selected orders
  const [selectedOrders, setSelectedOrders] = useState([]);

  useEffect(() => {
    let intervalId;

    async function fetchOrderContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-partially-paid-order`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.partialOrder)) {
          setPartialOrder(data.partialOrder);
          //console.log("data.partialOrder :", data.partialOrder);
        } else {
          console.error("Invalid response:", data);
          setPartialOrder([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending orders", err);
        setPartialOrder([]);
      }
    }

    fetchOrderContent(); // run once immediately

    // auto-refresh every 10 seconds
    intervalId = setInterval(fetchOrderContent, 10000);

    // cleanup on unmount or dependency change
    return () => clearInterval(intervalId);
  }, [updatePartialOrder]);

  // 🔹 Approve a single order
  // 🔹 Approve one order

  // ✅ filter orders based on search term
  const filteredOrders = partialOrder.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    const displayStatus =
      order.COI_Status === "PayFull" ? "DP PAID" : order.COI_Status || "";

    return (
      order.PD_Name?.toLowerCase().includes(keyword) ||
      order.PO_Number?.toLowerCase().includes(keyword) ||
      `${order.CP_Firstname} ${order.CP_Lastname}`
        .toLowerCase()
        .includes(keyword) ||
      displayStatus.toLowerCase().includes(keyword)
    );
  });

  // ✅ handle toggle of one row
  const handleRowSelect = (id) => {
    setSelectedOrders((prev) =>
      prev.includes(id) ? prev.filter((oid) => oid !== id) : [...prev, id]
    );
  };

  // ✅ handle toggle all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(filteredOrders.map((o) => o.COI_ID));
    } else {
      setSelectedOrders([]);
    }
  };

  // ✅ check if all are selected
  const allSelected =
    filteredOrders.length > 0 &&
    filteredOrders.every((o) => selectedOrders.includes(o.COI_ID));
  const handleUpdateAvailability = async (order) => {
    try {
      let ok;
      if (order.COI_IsReady === "true") {
        ok = window.confirm(`Mark as not Available?`);
      } else {
        ok = window.confirm(`Mark as  Available?`);
      }
      if (!ok) return;
      //console.log("order: ", order);
      // 1️⃣ Update order status to "Ready to Ship"
      const updateRes = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/update-availability`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            COI_ID: order.COI_ID,
            availability: order.COI_IsReady === "true" ? "false" : "true",
          }),
        }
      );

      if (!updateRes.ok) {
        throw new Error("Failed to update order status");
      }

      setUpdatePartialOrder((p) => !p);
      setCountListUpdate((prev) => !prev);
      // 3️⃣ Update the transactions state

      alert(`Order #${order.COI_ID} marked as Available ✅`);
    } catch (error) {
      console.error("Error updating order:", error);
      alert("Something went wrong while updating the order.");
    }
  };
  const handleBulkUpdateAvailability = async (asAvailable) => {
    try {
      let ok;
      let availability;
      if (asAvailable) {
        ok = window.confirm(`Mark selected as Available?`);
        availability = "true";
      } else {
        ok = window.confirm(`Mark selected as not Available?`);
        availability = "false";
      }
      if (!ok) return;

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/update-availability`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            COI_ID: selectedOrders,
            availability: availability,
          }),
        }
      );

      if (!res.ok) throw new Error("Bulk update failed");

      const data = await res.json();
      alert(data.message);

      setUpdatePartialOrder((p) => !p); // refresh table
      setCountListUpdate((prev) => !prev);
      setSelectedOrders([]); // clear selection
    } catch (err) {
      console.error("Bulk update error:", err);
      alert("Failed to update orders");
    }
  };
  return (
    <main className="ad-order-panel-container">
      <div className="order-panel-header">
        <div className="order-panel-title-wrapper">
          <span>PARTIALLY PAID</span>
        </div>
        <div className="order-panel-actions-wrapper">
          {/* ✅ Only show button when there are selected orders */}
          {selectedOrders.length > 0 && (
            <>
              <button
                onClick={() => {
                  handleBulkUpdateAvailability(true);
                }}
              >
                MARK AS AVAILABLE ({selectedOrders.length})
              </button>
              <button
                onClick={() => {
                  handleBulkUpdateAvailability(false);
                }}
              >
                MARK AS NOT AVAILABLE ({selectedOrders.length})
              </button>
            </>
          )}

          <div className="order-search-bar">
            <input
              type="text"
              placeholder="Keyword..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span>
              <FaSearch />
            </span>
          </div>
        </div>
      </div>

      <div className="order-panel-table-wrapper">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={handleSelectAll}
                />
              </th>
              <th></th>
              <th>PRODUCT NAME</th>
              <th>CUSTOMER NAME</th>
              <th>ORDER TYPE</th>
              <th>DATE ORDERED</th>
              <th>UNIT PRICE</th>
              <th>QTY</th>
              <th>TOTAL DP</th>
              <th>TOTAL AMOUNT</th>
              <th>DEPOSIT</th>
              <th>BALANCE</th>
              <th>STATUS</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <_OrderRow
                  key={order.COI_ID}
                  order={order}
                  menuOpenId={menuOpenId}
                  setMenuOpenId={setMenuOpenId}
                  isSelected={selectedOrders.includes(order.COI_ID)}
                  onSelect={() => handleRowSelect(order.COI_ID)}
                  setExpandedId={setExpandedId}
                  expandedId={expandedId}
                  handleUpdateAvailability={handleUpdateAvailability}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="15"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </main>
  );
}

export default _PartialPayment;
